export const countriesKYC = [
  {
    AF: {
      name: "Afghanistan",
      currency: "AFN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AL: {
      name: "Albania",
      currency: "ALL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    DZ: {
      name: "Algeria",
      currency: "DZD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AD: {
      name: "Andorra",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AO: {
      name: "Angola",
      currency: "AOA",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AG: {
      name: "Antigua and Barbuda",
      currency: "XCD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AR: {
      name: "Argentina",
      currency: "ARS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AM: {
      name: "Armenia",
      currency: "AMD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AU: {
      name: "Australia",
      currency: "AUD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AT: {
      name: "Austria",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AZ: {
      name: "Azerbaijan",
      currency: "AZN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BS: {
      name: "Bahamas",
      currency: "BSD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BH: {
      name: "Bahrain",
      currency: "BHD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BD: {
      name: "Bangladesh",
      currency: "BDT",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BB: {
      name: "Barbados",
      currency: "BBD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BY: {
      name: "Belarus",
      currency: "BYN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BE: {
      name: "Belgium",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BZ: {
      name: "Belize",
      currency: "BZD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BJ: {
      name: "Benin",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BT: {
      name: "Bhutan",
      currency: "BTN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BO: {
      name: "Bolivia",
      currency: "BOB",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BA: {
      name: "Bosnia and Herzegovina",
      currency: "BAM",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BW: {
      name: "Botswana",
      currency: "BWP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BR: {
      name: "Brazil",
      currency: "BRL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BN: {
      name: "Brunei",
      currency: "BND",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BG: {
      name: "Bulgaria",
      currency: "BGN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BF: {
      name: "Burkina Faso",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    BI: {
      name: "Burundi",
      currency: "BIF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CV: {
      name: "Cabo Verde",
      currency: "CVE",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KH: {
      name: "Cambodia",
      currency: "KHR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CM: {
      name: "Cameroon",
      currency: "XAF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CA: {
      name: "Canada",
      currency: "CAD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CF: {
      name: "Central African Republic",
      currency: "XAF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TD: {
      name: "Chad",
      currency: "XAF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CL: {
      name: "Chile",
      currency: "CLP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CN: {
      name: "China",
      currency: "CNY",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CO: {
      name: "Colombia",
      currency: "COP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KM: {
      name: "Comoros",
      currency: "KMF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CG: {
      name: "Republic of the Congo",
      currency: "XAF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CR: {
      name: "Costa Rica",
      currency: "CRC",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CI: {
      name: "Cote d'Ivoire",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    HR: {
      name: "Croatia",
      currency: "HRK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CU: {
      name: "Cuba",
      currency: "CUP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CY: {
      name: "Cyprus",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CZ: {
      name: "Czech Republic",
      currency: "CZK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CD: {
      name: "Democratic Republic of the Congo",
      currency: "CDF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    DK: {
      name: "Denmark",
      currency: "DKK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    DJ: {
      name: "Djibouti",
      currency: "DJF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    DM: {
      name: "Dominica",
      currency: "XCD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    DO: {
      name: "Dominican Republic",
      currency: "DOP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    EC: {
      name: "Ecuador",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    EG: {
      name: "Egypt",
      currency: "EGP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SV: {
      name: "El Salvador",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GQ: {
      name: "Equatorial Guinea",
      currency: "XAF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ER: {
      name: "Eritrea",
      currency: "ERN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    EE: {
      name: "Estonia",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SZ: {
      name: "Eswatini",
      currency: "SZL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ET: {
      name: "Ethiopia",
      currency: "ETB",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    FJ: {
      name: "Fiji",
      currency: "FJD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    FI: {
      name: "Finland",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    FR: {
      name: "France",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GA: {
      name: "Gabon",
      currency: "XAF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GM: {
      name: "Gambia",
      currency: "GMD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GE: {
      name: "Georgia",
      currency: "GEL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    DE: {
      name: "Germany",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GH: {
      name: "Ghana",
      currency: "GHS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },

      ],
    },
    GR: {
      name: "Greece",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GD: {
      name: "Grenada",
      currency: "XCD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GT: {
      name: "Guatemala",
      currency: "GTQ",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GN: {
      name: "Guinea",
      currency: "GNF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GW: {
      name: "Guinea-Bissau",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GY: {
      name: "Guyana",
      currency: "GYD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    HT: {
      name: "Haiti",
      currency: "HTG",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    VA: {
      name: "Holy See",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    HN: {
      name: "Honduras",
      currency: "HNL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    HU: {
      name: "Hungary",
      currency: "HUF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    IS: {
      name: "Iceland",
      currency: "ISK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    IN: {
      name: "India",
      currency: "INR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ID: {
      name: "Indonesia",
      currency: "IDR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    IR: {
      name: "Iran",
      currency: "IRR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    IQ: {
      name: "Iraq",
      currency: "IQD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    IE: {
      name: "Ireland",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    IL: {
      name: "Israel",
      currency: "ILS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    IT: {
      name: "Italy",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    JM: {
      name: "Jamaica",
      currency: "JMD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    JP: {
      name: "Japan",
      currency: "JPY",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    JO: {
      name: "Jordan",
      currency: "JOD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KZ: {
      name: "Kazakhstan",
      currency: "KZT",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KE: {
      name: "Kenya",
      currency: "KES",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KI: {
      name: "Kiribati",
      currency: "AUD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KW: {
      name: "Kuwait",
      currency: "KWD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KG: {
      name: "Kyrgyzstan",
      currency: "KGS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LA: {
      name: "Laos",
      currency: "LAK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LB: {
      name: "Lebanon",
      currency: "LBP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LS: {
      name: "Lesotho",
      currency: "LSL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LR: {
      name: "Liberia",
      currency: "LRD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LY: {
      name: "Libya",
      currency: "LYD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LI: {
      name: "Liechtenstein",
      currency: "CHF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LT: {
      name: "Lithuania",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LU: {
      name: "Luxembourg",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MG: {
      name: "Madagascar",
      currency: "MGA",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MW: {
      name: "Malawi",
      currency: "MWK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MY: {
      name: "Malaysia",
      currency: "MYR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MV: {
      name: "Maldives",
      currency: "MVR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ML: {
      name: "Mali",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MT: {
      name: "Malta",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MH: {
      name: "Marshall Islands",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MR: {
      name: "Mauritania",
      currency: "MRO",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MU: {
      name: "Mauritius",
      currency: "MUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MX: {
      name: "Mexico",
      currency: "MXN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    FM: {
      name: "Micronesia",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MD: {
      name: "Moldova",
      currency: "MDL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MC: {
      name: "Monaco",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MN: {
      name: "Mongolia",
      currency: "MNT",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ME: {
      name: "Montenegro",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MA: {
      name: "Morocco",
      currency: "MAD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MZ: {
      name: "Mozambique",
      currency: "MZN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MM: {
      name: "Myanmar",
      currency: "MMK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NA: {
      name: "Namibia",
      currency: "NAD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NR: {
      name: "Nauru",
      currency: "AUD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NP: {
      name: "Nepal",
      currency: "NPR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NL: {
      name: "Netherlands",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NZ: {
      name: "New Zealand",
      currency: "NZD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NI: {
      name: "Nicaragua",
      currency: "NIO",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NE: {
      name: "Niger",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NG: {
      name: "Nigeria",
      currency: "NGN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KP: {
      name: "North Korea",
      currency: "KPW",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    MK: {
      name: "North Macedonia",
      currency: "MKD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    NO: {
      name: "Norway",
      currency: "NOK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    OM: {
      name: "Oman",
      currency: "OMR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PK: {
      name: "Pakistan",
      currency: "PKR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PW: {
      name: "Palau",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PS: {
      name: "State of Palestine",
      currency: "ILS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PA: {
      name: "Panama",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PG: {
      name: "Papua New Guinea",
      currency: "PGK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PY: {
      name: "Paraguay",
      currency: "PYG",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PE: {
      name: "Peru",
      currency: "PEN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PH: {
      name: "Philippines",
      currency: "PHP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PL: {
      name: "Poland",
      currency: "PLN",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    PT: {
      name: "Portugal",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    QA: {
      name: "Qatar",
      currency: "QAR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    RO: {
      name: "Romania",
      currency: "RON",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    RU: {
      name: "Russia",
      currency: "RUB",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    RW: {
      name: "Rwanda",
      currency: "RWF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KN: {
      name: "Saint Kitts and Nevis",
      currency: "XCD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LC: {
      name: "Saint Lucia",
      currency: "XCD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    VC: {
      name: "Saint Vincent and the Grenadines",
      currency: "XCD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    WS: {
      name: "Samoa",
      currency: "WST",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SM: {
      name: "San Marino",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ST: {
      name: "Sao Tome and Principe",
      currency: "STD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SA: {
      name: "Saudi Arabia",
      currency: "SAR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SN: {
      name: "Senegal",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    RS: {
      name: "Serbia",
      currency: "RSD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SC: {
      name: "Seychelles",
      currency: "SCR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SL: {
      name: "Sierra Leone",
      currency: "SLL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SG: {
      name: "Singapore",
      currency: "SGD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SK: {
      name: "Slovakia",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SI: {
      name: "Slovenia",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SB: {
      name: "Solomon Islands",
      currency: "SBD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SO: {
      name: "Somalia",
      currency: "SOS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ZA: {
      name: "South Africa",
      currency: "ZAR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    KR: {
      name: "South Korea",
      currency: "KRW",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SS: {
      name: "South Sudan",
      currency: "SSP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ES: {
      name: "Spain",
      currency: "EUR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    LK: {
      name: "Sri Lanka",
      currency: "LKR",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SD: {
      name: "Sudan",
      currency: "SDG",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SR: {
      name: "Suriname",
      currency: "SRD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SE: {
      name: "Sweden",
      currency: "SEK",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    CH: {
      name: "Switzerland",
      currency: "CHF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    SY: {
      name: "Syria",
      currency: "SYP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TJ: {
      name: "Tajikistan",
      currency: "TJS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TZ: {
      name: "Tanzania",
      currency: "TZS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TH: {
      name: "Thailand",
      currency: "THB",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TL: {
      name: "Timor-Leste",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TG: {
      name: "Togo",
      currency: "XOF",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TO: {
      name: "Tonga",
      currency: "TOP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TT: {
      name: "Trinidad and Tobago",
      currency: "TTD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TN: {
      name: "Tunisia",
      currency: "TND",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TR: {
      name: "Turkey",
      currency: "TRY",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TM: {
      name: "Turkmenistan",
      currency: "TMT",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    TV: {
      name: "Tuvalu",
      currency: "AUD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    UG: {
      name: "Uganda",
      currency: "UGX",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    UA: {
      name: "Ukraine",
      currency: "UAH",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    AE: {
      name: "United Arab Emirates",
      currency: "AED",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    GB: {
      name: "United Kingdom",
      currency: "GBP",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    US: {
      name: "United States of America",
      currency: "USD",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    UY: {
      name: "Uruguay",
      currency: "UYU",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    UZ: {
      name: "Uzbekistan",
      currency: "UZS",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    VU: {
      name: "Vanuatu",
      currency: "VUV",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    VE: {
      name: "Venezuela",
      currency: "VES",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    VN: {
      name: "Vietnam",
      currency: "VND",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    YE: {
      name: "Yemen",
      currency: "YER",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ZM: {
      name: "Zambia",
      currency: "ZMW",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
    ZW: {
      name: "Zimbabwe",
      currency: "ZWL",
      documents: [
        {
          type: "Passport",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "National identity card",
          front_image_required: true,
          back_image_required: true,
        },
        {
          type: "Driver's license",
          front_image_required: true,
          back_image_required: false,
        },
        {
          type: "Residence permit",
          front_image_required: true,
          back_image_required: true,
        },
      ],
    },
  },
];
